<template>
    <div>
        <div class="order-header mb-20">
            <i class="ion-gear-a"></i>
            <h2>Wybierz rodzaj dostawy</h2>
        </div>
        <div class="order-vendor-information">
            <div class="option-container main-option-container">
                <div class="option2" v-on:click="setDeliveryType(1)" v-bind:class="{ 'option-active': delivery.withCarry == 1 }">
                    <p>Dostawa z wniesieniem</p>
                </div>
                <div class="option2" v-on:click="setDeliveryType(0)"  v-bind:class="{ 'option-active': delivery.withCarry == 0 }">
                    <p>Dostawa bez wniesienia</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'deliveryTypeBox',
        props: ['delivery', 'step'],
        data () {
            return {}
        },

        methods: {
            setDeliveryType: function(v) {
                this.delivery.withCarry = v;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DeliveryTypeBox.vue?3c674310